import { usePageContext } from 'vike-react/usePageContext';

export { PLUS_ENABLED_COOKIE, PLUS_ENABLED_DEFAULT, PLUS_FLAG_KEY } from './plus-flag-constants';

/**
 * Whether JobCrawls Plus is open to this visitor (TEC-744). Decided on the server per account
 * (server/plus/plus-audience.ts): during internal testing only staff accounts, everyone else gets
 * today's free site. Locally the `dev_enable_plus` cookie decides. With it off no Plus entry point
 * is shown and PlusGate renders the free experience.
 */
export function usePlusEnabled(initialValue?: boolean): boolean {
  // The server decides per account (server/plus/plus-audience.ts: staff only while Plus is in
  // internal testing) and passes pageContext.plusEnabled to the client. The client never
  // re-reads the cookie, so a visitor who sets it sees nothing new (and the APIs answer 404).
  const fromServer = (usePageContext() as { plusEnabled?: boolean } | undefined)?.plusEnabled;
  return initialValue ?? fromServer ?? false;
}
